import environment from '../environment';
import { pinBuilder } from '../core/map/pinBuilder';
import Promise from 'bluebird';
import templates from '../core/templates';
import Leaflet from './Leaflet';
import ColorBrewer from '../core/tools/colorbrewer';
import worldMap from '../core/map';

class FarmMachineLayer {
  constructor(currentMap) {
    const clusterImage = new Image();
    clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_greenfield.png`;

    const onClick = (feature, layer) => { };

    const clusterTemplate = cluster => {
      const data = {
        value: cluster.getAllChildMarkers().length,
      };

      return pinBuilder.create.pin.imageWithValue(data, clusterImage);
    };

    const createPopupTemplate = (properties, layer) =>
      new Promise((resolve, reject) => {

        const title = properties.Name || properties.NameBrand;
        const $template = $(templates('map-layer-farm-machine-popup', {title, ...properties}));

        resolve($template);
      });

    const createClusterPopupTemplate = features => {
      if (worldMap.getZoom() < 8) return;

      const getBrand = x => x.feature.properties.NameBrand;
      const qttPerBrand = brand => features.filter(x => getBrand(x) === brand).length;
      const brands = features.map(getBrand).distinctBy(x => x).map(x => ({
        name: x,
        qtt: qttPerBrand(x)
      }));

      const qttOnPopUp = 10;
      const properties = {
        brands: brands.slice(0, qttOnPopUp),
        wrap: brands.length >= qttOnPopUp,
        totalBrands: brands.length,
        totalFarmMachines: features.length
      };

      return new Promise((resolve, reject) => {
        const template = $(templates('map-layer-farm-machine-cluster-popup', properties));
        resolve(template);
      });
    };

    return new Leaflet.D3Layer({
      map: currentMap,
      id: `spatial_farm_machine_layer`,
      remote: {
        method: 'POST',
        url: `${environment.get('API_HOST')}/Layer/GetFarmMachines`,
        params: { }
      },
      scaleRange: [5, 20],
      showAll: false,
      autofocus: false,
      uniqueField: 'Id',
      sort: 'Name',
      click: onClick,
      popup: {
        template: createPopupTemplate,
        clusterTemplate: createClusterPopupTemplate,
        trigger: 'mouseover',
        options: {
          offset: L.point(0, -10),
          closeButton: false,
          autoclose: true
        },
        single: true
      },
      type: 'cluster',
      symbology: {
        type: 'polymorph',
        cluster: {
          disableAtZoom: 20,
          template: clusterTemplate
        },
        heat: {
          theme: ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_GREEN)
        },
        style: {
          icon: {
            iconUrl: `${environment.get('IMAGES_HOST')}/pin_trator_verde.png`,
            iconSize: [40, 51],
            iconAnchor: [20, 48],
            labelAnchor: [25, -32]
          },
          riseOnHover: true
        }
      }
    });
  }
}

export default FarmMachineLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/FarmMachineLayer.js